import { createContext } from "react";
import type { FormConfig } from "@/types/FormConfig";

export const ConfigContext = createContext<FormConfig | null>(null);
